import React from "react";
export const EVoucherActionDropdown = (props) => {
  const {
    buttonClassName,
    actionTitle,
    total,
    selectedEVouchersLength,
    hasAnyCriterionValue,
    onClickAll,
    onClickSelectedEVouchers,
  } = props;
  return (
    <div className="dropdown mr-2">
      <button
        className={`btn ${buttonClassName} dropdown-toggle text-white`}
        type="button"
        data-toggle="dropdown"
      >
        {actionTitle}
        <span className="caret"></span>
      </button>
      <ul className="dropdown-menu p-2">
        <li>
          {!hasAnyCriterionValue() && (
            <span
              style={{
                fontSize: 12,
                fontWeight: 400,
                color: "orange",
              }}
            >
              <i className="fa fa-exclamation mr-2"></i>{actionTitle} all is only
              allowed after the user has applied at least one criterion.
              <br />
            </span>
          )}
          <button
            disabled={!hasAnyCriterionValue()}
            className={`btn ${buttonClassName} text-white`}
            onClick={() => onClickAll()}
          >
            {actionTitle} All ({total})
          </button>
        </li>
        <li>
          <button
            className="btn btn-outline-secondary mt-1"
            onClick={() => onClickSelectedEVouchers()}
          >
            {actionTitle} Selected eVouchers ({selectedEVouchersLength})
          </button>
        </li>
      </ul>
    </div>
  );
};
